// extracted by mini-css-extract-plugin
export default {"container":"UserNotification_container__EaFht","action":"UserNotification_action__rj9YC","count":"UserNotification_count__BPof-"};